/**
 * 系统管理  角色管理
 */
<template>
  <div class="main">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>角色管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">

      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.name" placeholder="输入角色名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" type="selection" width="60">
      </el-table-column>
      <el-table-column sortable prop="roleName" label="角色名称" width="120">
      </el-table-column>
      <el-table-column sortable prop="roleCode" label="角色代码" width="120">
      </el-table-column>
	  <el-table-column sortable prop="dataRange" label="可见人" width="200">
	  </el-table-column>
	  <el-table-column sortable prop="sorted" label="角色排序" width="100">
	  </el-table-column>
      <el-table-column sortable prop="updateTime" label="修改时间" width="180">
        <template slot-scope="scope">
          <div>{{scope.row.updateTime|timestampToTime}}</div>
        </template>
      </el-table-column>
	  <el-table-column sortable prop="createTime" label="创建时间" width="180">
	    <template slot-scope="scope">
	      <div>{{scope.row.createTime|timestampToTime}}</div>
	    </template>
	  </el-table-column>
      <el-table-column sortable prop="editUser" label="修改人" width="120">
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="300">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <!-- <el-button size="mini" type="danger" @click="deleteUser(scope.$index, scope.row)">删除</el-button>
          <el-button size="mini" type="success" @click="menuAccess(scope.$index, scope.row)">菜单权限</el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="40%" @click='closeDialog("edit")'>
      <el-form label-width="120px" :model="editForm" ref="editForm" :rules="rules">
        <el-form-item label="角色代码" prop="roleCode">
          <el-input size="small" v-model="editForm.roleCode" auto-complete="off" placeholder="请输入系统编码"></el-input>
        </el-form-item>
        <el-form-item label="角色名称" prop="roleName">
          <el-input size="small" v-model="editForm.roleName" auto-complete="off" placeholder="请输入角色名称"></el-input>
        </el-form-item>
        <el-form-item label="角色排序" prop="sorted">
          <el-input size="small" v-model="editForm.sorted" type="number" auto-complete="off" placeholder="请输入角色代码"></el-input>
        </el-form-item>
		<el-form-item label="可见人" prop="dataRange">
		  <el-select size="small" v-model="editForm.dataRange" placeholder="请选择" class="userRole">
		  		<el-option v-for="(item,index)  in dataRanges" :key="index" :label="item.dataRangeName" :value="item.dataRangeCode"></el-option>
		  </el-select>
		</el-form-item>
		<el-form-item label="菜单权限" prop="appMenuList">

		 <el-button @click="menu" v-if="menuListshow==1">修改菜单权限</el-button>
		 <el-button @click="menuadd" v-if="menuListshow==0">添加菜单权限</el-button>
		</el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("edit")'>取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
      </div>
    </el-dialog>
    <!-- 修改菜单权限 -->
    <el-dialog title="修改菜单权限" :visible.sync="menuAccessshow" width="40%" @click='closeDialog("perm")'>
      <el-tree
        :props="props"
        :data="appMenuList"
		:default-checked-keys="editmenuList"
		node-key="id"
        show-checkbox
        @check-change="handleCheckChange"
        ref="tree"
		v-if="menuListshow==1">
      </el-tree>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("perm")'>取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="getCheckedNodes">保存</el-button>
      </div>
    </el-dialog>
	<!-- 添加菜单权限 -->
	<el-dialog title="添加菜单权限" :visible.sync="menuAccessshows" width="30%" @click='closeDialog("perms")'>
	  <el-tree
	    :props="props"
	    :data="appMenuList"
	    show-checkbox
	    @check-change="handleCheckChange"
	    ref="treeadd">
	  </el-tree>
	  <div slot="footer" class="dialog-footer">
	    <el-button size="small" @click='closeDialog("perms")'>取消</el-button>
	    <el-button size="small" type="primary" :loading="loading" class="title" @click="addCheckedNodes">保存</el-button>
	  </div>
	</el-dialog>
  </div>
</template>

<script>
import {
  roleList,
  roleSave,
  roleDetails,
  roleAdd,
  roleDelete,
  rolePwd,
  RoleRightTree,
  RoleRightSave
} from '../../api/userMG'
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      menuAccessshow: false, //控制数据权限显示与隐藏
	  menuAccessshows: false, //控制数据权限显示与隐藏
      title: '添加',
	  editmenuList:'',
	  menuListshow:0,
      editForm: {
        roleId: '',
        roleName: '',
		appMenuList:{
			WEB:''
		},
		roleCode:'',
		sorted:'',
		dataRange:''
      },
	  appMenuList:'',
	  dataRanges:[
		  {
			  dataRangeName:'公司数据',
			  dataRangeCode:'COMPANY'

			},
			{
			  dataRangeName:'部门数据',
			  dataRangeCode:'DEPARTMENT'

			},
			{
			  dataRangeName:'个人数据',
			  dataRangeCode:'PERSONAL'

			}
		  ],
	  props: {
		children: 'children',
		label: 'label'
	  },
      // rules 表单验证
      rules: {
        systemNo: [
          { required: true, message: '请输入系统编码', trigger: 'blur' }
        ],
        roleNo: [
          { required: true, message: '请输入角色代码', trigger: 'blur' }
        ],
        roleName: [
          { required: true, message: '请输入角色名称', trigger: 'blur' }
        ],
		sorted: [
		  { required: true, message: '请输入角色排序', trigger: 'blur' }
		]
      },
      formInline: {
        pageIndex: 1,
        pageSize: 10,
        name: ''
      },
      // 删除
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 数据权限
      RoleRight: [],
      RoleRightProps: {
        children: 'children',
        label: 'name'
      },
      // 选中
      checkmenu: [],
      //参数role
      saveroleId: '',
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
	  RoleRightTree:{
		 name:'' ,
		 parentMenuCode:'',
		 pageIndex:1,
		 pageSize:10
	  }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  watch: {},

  /**
   * 创建完毕
   */

  created() {
    this.getdata(this.formInline)
	this.menuAccess()
  },

  /**
   * 里面的方法只有被调用才会执行
   */

  methods: {
	handleCheckChange(data, checked, indeterminate) {
		  console.log(33,data);
		},
	getCheckedNodes() {
			let that = this
			let appMenuList= this.$refs.tree.getCheckedNodes()
	        console.log(this.$refs.tree.getCheckedNodes());
			let WEB = []
			let appMenuLists = {}
			appMenuList.map((item,index) =>{
				WEB.push(item.id)
			})
			appMenuLists.WEB = WEB
			console.log(669,that.editForm.appMenuList,appMenuLists);
			that.editForm.appMenuList = appMenuLists
			console.log(667,that.editForm.appMenuList);
			this.menuAccessshow = false
	      },
	addCheckedNodes() {
		let that = this
		let appMenuList= this.$refs.treeadd.getCheckedNodes()
		  console.log(this.$refs.treeadd.getCheckedNodes());
		let WEB = []
		let appMenuLists = {}
		appMenuList.map((item,index) =>{
			WEB.push(item.id)
		})
		appMenuLists.WEB = WEB
		console.log(669,that.editForm.appMenuList,appMenuLists);
		that.editForm.appMenuList = appMenuLists
		console.log(667,that.editForm.appMenuList);
		this.menuAccessshows = false
		},
    //角色列表
    getdata(parameter){
	  roleList(parameter)
		.then(res => {
		  this.loading = false
		  if (res.success == false) {
			this.$message({
			  type: 'info',
			  message: res.msg+'TraceId:'+res.traceId
			})
		  } else {
			this.listData = res.data

		   }
		   // 分页赋值
		   this.pageparm.currentPage = this.formInline.pageIndex
		   this.pageparm.pageSize = this.formInline.pageSize
		   this.pageparm.total = res.total
		})
		.catch(error => {

		  this.loading = false
		  this.$message.error('获取角色列表失败，请稍后再试！'+'TraceId:'+res.traceId)
		})
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.pageIndex = parm.currentPage
      this.formInline.pageSize = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.formInline.pageIndex = 1
      this.getdata(this.formInline)
    },
	//截取数据
	getDecimalPart(str) {
	  const match = str.match(/\.(\d+)/);
	  return match ? match[1] : '';
	},
    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormVisible = true
	  this.editmenuList = ''
      if (row != undefined && row != 'undefined') {
        this.title = '修改角色'
		roleDetails(row.roleCode)
		  .then(res => {
		    if (res.success) {
		    this.menuListshow = 1
		     this.editForm.roleId = row.creatorId
		     this.editForm.roleName = res.data.roleName
		     this.editForm.appMenuList = res.data.appMenuTrees.WEB
		     this.editForm.roleCode = res.data.roleCode
			 this.editForm.sorted = res.data.sorted
			 this.editForm.dataRange = res.data.dataRange
			 this.editmenuList = res.data.appMenuList.WEB
		    } else {
		      this.$message({
		        type: 'info',
		        message: res.msg
		      })
		    }
		  })

      } else {
        this.title = '添加角色'
		this.menuListshow = 0
        this.editForm.roleId = ''
        this.editForm.roleName = ''
        this.editForm.roleCode = ''
        this.editForm.sorted = ''
        this.editForm.dataRange = ''
      }
    },

    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
			if(this.title=='修改角色'){
        
        this.editForm.sorted = parseInt(this.editForm.sorted)
				console.log(666,this.editForm)
			  roleSave(this.editForm)
				.then(res => {
				  this.editFormVisible = false
				  this.loading = false
				  if (res.success) {
					this.getdata(this.formInline)
					this.$message({
					  type: 'success',
					  message: '角色保存成功！'
					})
				  } else {
					this.$message({
					  type: 'info',
					  message: res.msg
					})
				  }
				})
			}else{
				roleAdd(this.editForm)
				.then(res => {
				  this.editFormVisible = false
				  this.loading = false
				  if (res.success) {
					this.getdata(this.formInline)
					this.$message({
					  type: 'success',
					  message: '角色添加成功！'
					})
				  } else {
					this.$message({
					  type: 'info',
					  message: res.msg
					})
				  }
				})
			}


        } else {
          return false
        }
      })
    },
    // 删除角色
    deleteUser(index, row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          roleDelete(row.roleId)
            .then(res => {
              if (res.success) {
                this.$message({
                  type: 'success',
                  message: '角色已删除！'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })

        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
	//显示菜单
	menu(){
		this.menuAccessshow = true

	},
	//添加显示菜单
	menuadd(){
		this.menuAccessshows = true

	},
    // 数据权限
    menuAccess: function(index, row) {
       //this.menuAccessshow = true
      // this.saveroleId = row.roleId
      RoleRightTree()
        .then(res => {
          if (res.code==200) {
            this.$message({
              type: 'success',
              message: '获取权限成功'
            })
			this.appMenuList = res.data

          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })

    },


    // 关闭编辑、增加弹出框
    closeDialog(dialog) {
      if (dialog == 'edit') {
        this.editFormVisible = false
      } else if (dialog == 'perm') {
        this.menuAccessshow = false
      }else{
        this.menuAccessshows = false
      }
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
.main{
	background-color: #fff;
	padding: 30px;
	border-radius: 10px;
}
</style>




// WEBPACK FOOTER //
// src/views/system/Role.vue